import { NgModule, ModuleWithProviders } from '@angular/core';
import { DomService } from './services/dom-service/dom.service';

@NgModule({
  declarations: [],
  imports: [],
})
export class DOMModule {
  static forRoot(domService: DomService): ModuleWithProviders<any> {
    return {
      ngModule: DOMModule,
      providers: [
        { provide: DomService },
      ],
    };
  }
}
